/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PortalAccessStatus;

(function (PortalAccessStatus) {
  PortalAccessStatus["NOT_INVITED"] = "not_invited";
  PortalAccessStatus["INVITATION_SENT"] = "invitation_sent";
  PortalAccessStatus["ACCESS_ACTIVATED"] = "access_activated";
  PortalAccessStatus["ACCESS_ISSUE"] = "access_issue";
  PortalAccessStatus["ACCESS_REMOVED"] = "access_removed";
})(PortalAccessStatus || (PortalAccessStatus = {}));